export enum DocumentType {
  RequestAdditionalNationalId = 1,
  RequestAdditionalPassport = 2,
  RequestAdditionalGenericPOI = 3,
  RequestAdditionalPOI = 4,
  RequestAdditionalResidencePermit = 5,
  RequestAddressClarification = 6,
  RequestBackSidePOI = 7,
  RequestUsCitizenClassification = 8,
  RequestBankStatement = 9,
  RequestBelgiumCommerciallyApproached = 10,
  RequestDrivingLicense = 11,
  RequestFrontSidePOI = 12,
  RequestNationalInsuranceNumber = 13,
  RequestPasswordForDocument = 14,
  RequestPOA = 15,
  RequestProofOfDeposit = 16,
}

// export enum POIDocumentType {
//   BacksidePOI = 'backside-poi',
//   FrontsidePOI = 'frontside-poi',
//   AdditionalPOI = 'additional-poi',
//   AddressClarification = 'address-clarification',
//   AdditionalPOIGeneric = 'additional-poi-generic',
//   UsCitizenClassification = 'us-citizen-classification',
//   BelgiumEmail = 'belgium-email',
//   AdditionalNationalId = 'additional-national-id',
//   AdditionalPassport = 'additional-passport',
//   AdditionalResidencePermit = 'additional-residence-permit',
//   NationalInsuranceNumber = 'national-insurance-number',
//   DrivingLicense = 'driving-license',
//   BankStatement = 'bank-statement',
//   POA = 'poa',
//   ProofOfDeposit = 'proof-of-deposit',
//   NameEmail = 'name-email',
//   DateOfBirth = 'date-of-birth-email',
// }

export enum POIDocumentType {
  BacksidePOI = 'backside-poi',
  FrontsidePOI = 'frontside-poi',
  AdditionalPOI = 'additional-poi',
  AddressClarification = 'address-clarification',
  AdditionalPOIGeneric = 'additional-poi-generic',
  UsCitizenClassification = 'us-citizen-classification',
  BelgiumEmail = 'belgium-email',
  AdditionalNationalId = 'additional-national-id',
  AdditionalPassport = 'additional-passport',
  AdditionalResidencePermit = 'additional-residence-permit',
  NationalInsuranceNumber = 'national-insurance-number',
  DrivingLicense = 'driving-license',
  BankStatement = 'bank-statement',
  POA = 'poa',
  ProofOfDeposit = 'proof-of-deposit',
  NameEmail = 'name-email',
  DateOfBirth = 'date-of-birth-email',
}
